import { ComponentPropsWithoutRef, ReactNode } from 'react';

import classNames from 'classnames';
import { Command } from 'cmdk';

import { comboboxStyles } from '../combobox.styles';
import { useComboboxContext } from '../ComboboxContext';

export interface ComboboxOptionsProps extends ComponentPropsWithoutRef<'div'> {
  children?: ReactNode;
}

export const ComboboxOptions = ({ className, children, ...rest }: ComboboxOptionsProps) => {
  const { classNames: contextClassNames } = useComboboxContext();
  const styles = comboboxStyles();

  return (
    <Command.List
      {...rest}
      className={classNames(styles.options(), contextClassNames?.options, className)}
    >
      {children}
    </Command.List>
  );
};
